import React, {useState, useEffect} from 'react';
import {Button, Col, Modal, Row, Spin, Upload, DatePicker, notification, Input} from "antd";
import {approveOrderService} from "../../../services/approve-order.service";
import i18n from '../../../i18n';
import InputField from '../../input-field';
import FieldBlock from '../../field-block';
import DividerBlock from '../../divider-block';
import moment from "moment";
import '../modals.css';

export default function ModalEditContractOrder({
  contractId,
  isShow,
  onCloseModal,
  setNeedUpdate,
}) {
  const [loadingContentModal, setLoadingContentModal] = useState(true);
  const [loading, setLoading] = useState(false);
  const [fieldsErrors, setFieldsErrors] = useState([]);
  const [data, setData] = useState({});
  const [docsList, setDocsList] = useState([]);

  const [fullNumber, setFullNumber] = useState(null);
  const [contractDate, setContractDate] = useState(null);

  let bigButtonStyle = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px'
  };
  
  let dividerStyle = {
    margin: '15px 0px 45px 0px',
    display: "block",
    clear: "both",
    width: "100%",
    minWidth: "100%",
    height: "1px"
  };

  useEffect(() => {
    if (isShow && contractId) {
      setLoadingContentModal(true);
      approveOrderService.getContractOrderEditData(contractId)
        .then((response) => {
          setData(response);
          setFullNumber(response.fullNumber || '');
          setContractDate(response.contractDate ? moment(response.contractDate, 'YYYY-MM-DD') : null);
          setDocsList(response.docs || []);
          setLoadingContentModal(false);
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('components.notification.titles.getContractOrderEditData'),
            description: err
          });
          setLoadingContentModal(false);
        });
    }
  }, [isShow, contractId]);

  const getFieldErrors = (fieldName) => {
    return typeof fieldsErrors[fieldName] !== "undefined"
      ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
        return fieldErrors + "; " + error;
      })
      : null;
  };

  const onClickSave = () => {
    setLoading(true);

    const files = [];
    for (let i = 0; i < docsList.length; i++) {
      const doc = docsList[i];
      if (doc.newBlankFile && doc.newBlankFile instanceof File) {
        files.push({
          name: doc.name + '_blank',
          file: doc.newBlankFile,
          fileType: doc.name,
          fileTypeUpload: 'blank'
        });
      }
      if (doc.newUploadedFile && doc.newUploadedFile instanceof File) {
        files.push({
          name: doc.name + '_uploaded',
          file: doc.newUploadedFile,
          fileType: doc.name,
          fileTypeUpload: 'uploaded'
        });
      }
    }

    approveOrderService.saveContractOrderEditData(
      contractId,
      fullNumber || '',
      contractDate ? contractDate.format('YYYY-MM-DD') : '',
      files
    )
      .then((response) => {
        setLoading(false);
        if (response.status === 'success') {
          notification.success({
            message: i18n.t('Редактирование договора'),
            description: response.message,
          });
          onCloseModal(true);
          if (setNeedUpdate) {
            setNeedUpdate(true);
          }
        } else if (response.status === 'error') {
          setFieldsErrors(response.errors || []);
          if (response.message) {
            notification.error({
              message: i18n.t('Редактирование договора'),
              description: response.message,
            });
          }
        }
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('Редактирование договора'),
          description: error,
        });
        setLoading(false);
      });
  };

  const getUploaderProps = (index, fileType) => {
    const doc = docsList[index];
    if (!doc) return {};

    const file = fileType === 'blank' ? doc.newBlankFile : doc.newUploadedFile;

    return {
      multiple: false,
      showUploadList: true,
      onRemove: () => {
        let docs = [...docsList];
        if (fileType === 'blank') {
          docs[index].newBlankFile = null;
        } else if (fileType === 'uploaded') {
          docs[index].newUploadedFile = null;
        }
        setDocsList(docs);
      },
      beforeUpload: (file) => {
        let docs = [...docsList];
        if (fileType === 'blank') {
          docs[index].newBlankFile = file;
        } else if (fileType === 'uploaded') {
          docs[index].newUploadedFile = file;
        }
        setDocsList(docs);
        return false;
      },
      fileList: file ? [{
        uid: '-1',
        name: file.name || 'file',
        url: file instanceof File ? URL.createObjectURL(file) : file,
        status: 'done',
      }] : [],
      listType: 'picture',
    };
  };

  const handleDownloadDoc = (fileUrl) => {
    if (fileUrl) {
      window.open(fileUrl);
    }
  };

  const renderDocsForm = () => {
    return docsList.map((value, index) => {
      return (
        <Col lg={12} md={24} sm={24} xs={24} key={index} style={{marginBottom: '16px'}}>
          <div style={{marginBottom: '8px'}}><p>{value.alias}</p></div>
          {/* Шаблон документа */}
          <div style={{marginBottom: '8px'}}>
            {value.blankFile && (
              <Button 
                onClick={() => handleDownloadDoc(value.blankFile)} 
                size="small"
                className="small-button typical-btn-blue"
                style={{marginRight: '8px'}}
              >
                {i18n.t('main.buttons.download')} {i18n.t('modals.modalEditContractOrder.blankFile')}
              </Button>
            )}
            <Upload
              className="single-btn-upload"
              name={value.name + '_blank'}
              {...getUploaderProps(index, 'blank')}
            >
              <Button htmlType="button" size="small">
                <svg width="17" height="22" viewBox="0 0 17 22" fill="none"
                     xmlns="http://www.w3.org/2000/svg" className="download-file-svg">
                  <path
                    d="M11.5631 0.165835C11.4647 0.0622087 11.3298 0 11.19 0H2.81953C1.27495 0 0 1.26988 0 2.81429V18.643C0 20.1875 1.27495 21.4574 2.81953 21.4574H14.1805C15.725 21.4574 17 20.1875 17 18.643V6.07435C17 5.93962 16.9378 5.81013 16.8497 5.71158L11.5631 0.165835ZM11.7134 1.82959L15.2534 5.54574H12.9522C12.268 5.54574 11.7134 4.99634 11.7134 4.31221V1.82959ZM14.1805 20.4208H2.81953C1.85038 20.4208 1.03659 19.6175 1.03659 18.643V2.81429C1.03659 1.84514 1.84514 1.03659 2.81953 1.03659H10.6768V4.31221C10.6768 5.57161 11.6928 6.58233 12.9522 6.58233H15.9634V18.643C15.9634 19.6175 15.1549 20.4208 14.1805 20.4208Z"
                    fill="#1CAA53"></path>
                  <path
                    d="M12.7642 16.8447H4.23314C3.94813 16.8447 3.71484 17.0778 3.71484 17.363C3.71484 17.648 3.94813 17.8813 4.23314 17.8813H12.7695C13.0545 17.8813 13.2878 17.648 13.2878 17.363C13.2878 17.0778 13.0545 16.8447 12.7642 16.8447Z"
                    fill="#1CAA53"></path>
                  <path
                    d="M5.84741 11.268L7.9828 8.97187V14.6317C7.9828 14.9167 8.21608 15.15 8.5011 15.15C8.78627 15.15 9.01939 14.9167 9.01939 14.6317V8.97187L11.1548 11.268C11.2584 11.3767 11.3933 11.4339 11.5331 11.4339C11.6575 11.4339 11.7872 11.3872 11.8856 11.2939C12.093 11.097 12.1085 10.7704 11.9116 10.5631L8.87435 7.30304C8.7758 7.19942 8.64107 7.13721 8.49602 7.13721C8.35081 7.13721 8.21608 7.19942 8.11769 7.30304L5.08044 10.5631C4.8835 10.7704 4.89906 11.102 5.10631 11.2939C5.32404 11.4908 5.65047 11.4753 5.84741 11.268Z"
                    fill="#1CAA53"></path>
                </svg>
                {i18n.t('main.buttons.replace')} {i18n.t('modals.modalEditContractOrder.blankFile')}
              </Button>
            </Upload>
          </div>
          
          {/* Загруженный документ */}
          <div style={{marginBottom: '8px'}}>
            {value.uploadedFile && (
              <Button 
                onClick={() => handleDownloadDoc(value.uploadedFile)} 
                size="small"
                className="small-button typical-btn-green"
                style={{marginRight: '8px'}}
              >
                {i18n.t('main.buttons.download')} {i18n.t('modals.modalEditContractOrder.uploadedFile')}
              </Button>
            )}
            <Upload
              className="single-btn-upload"
              name={value.name + '_uploaded'}
              {...getUploaderProps(index, 'uploaded')}
            >
              <Button htmlType="button" size="small">
                <svg width="17" height="22" viewBox="0 0 17 22" fill="none"
                     xmlns="http://www.w3.org/2000/svg" className="download-file-svg">
                  <path
                    d="M11.5631 0.165835C11.4647 0.0622087 11.3298 0 11.19 0H2.81953C1.27495 0 0 1.26988 0 2.81429V18.643C0 20.1875 1.27495 21.4574 2.81953 21.4574H14.1805C15.725 21.4574 17 20.1875 17 18.643V6.07435C17 5.93962 16.9378 5.81013 16.8497 5.71158L11.5631 0.165835ZM11.7134 1.82959L15.2534 5.54574H12.9522C12.268 5.54574 11.7134 4.99634 11.7134 4.31221V1.82959ZM14.1805 20.4208H2.81953C1.85038 20.4208 1.03659 19.6175 1.03659 18.643V2.81429C1.03659 1.84514 1.84514 1.03659 2.81953 1.03659H10.6768V4.31221C10.6768 5.57161 11.6928 6.58233 12.9522 6.58233H15.9634V18.643C15.9634 19.6175 15.1549 20.4208 14.1805 20.4208Z"
                    fill="#1CAA53"></path>
                  <path
                    d="M12.7642 16.8447H4.23314C3.94813 16.8447 3.71484 17.0778 3.71484 17.363C3.71484 17.648 3.94813 17.8813 4.23314 17.8813H12.7695C13.0545 17.8813 13.2878 17.648 13.2878 17.363C13.2878 17.0778 13.0545 16.8447 12.7642 16.8447Z"
                    fill="#1CAA53"></path>
                  <path
                    d="M5.84741 11.268L7.9828 8.97187V14.6317C7.9828 14.9167 8.21608 15.15 8.5011 15.15C8.78627 15.15 9.01939 14.9167 9.01939 14.6317V8.97187L11.1548 11.268C11.2584 11.3767 11.3933 11.4339 11.5331 11.4339C11.6575 11.4339 11.7872 11.3872 11.8856 11.2939C12.093 11.097 12.1085 10.7704 11.9116 10.5631L8.87435 7.30304C8.7758 7.19942 8.64107 7.13721 8.49602 7.13721C8.35081 7.13721 8.21608 7.19942 8.11769 7.30304L5.08044 10.5631C4.8835 10.7704 4.89906 11.102 5.10631 11.2939C5.32404 11.4908 5.65047 11.4753 5.84741 11.268Z"
                    fill="#1CAA53"></path>
                </svg>
                {i18n.t('main.buttons.replace')} {i18n.t('modals.modalEditContractOrder.uploadedFile')}
              </Button>
            </Upload>
          </div>
        </Col>
      );
    });
  };

  return (
    <Modal
      title={i18n.t('modals.modalEditContractOrder.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        onCloseModal();
        setFieldsErrors([]);
      }}
      footer={[
        <Button 
          htmlType="submit" 
          key="submit" 
          style={bigButtonStyle} 
          type="primary"
          onClick={onClickSave}
        >
          {i18n.t('main.buttons.save')}
        </Button>,
      ]}
    >
      <Spin spinning={loadingContentModal} tip={i18n.t('main.loadText.loading')}>
        <Row gutter={[16, 24]}>
          <Col lg={12} md={24} sm={24} xs={24}>
            <InputField
              name="fullNumber"
              label={i18n.t('modals.modalEditContractOrder.fields.fullNumber.title')}
              value={fullNumber}
              setValue={setFullNumber}
              getFieldErrors={getFieldErrors}
              onInputChange={(e) => {
                setFullNumber(e.target.value);
              }}
            />
          </Col>
          <Col lg={12} md={24} sm={24} xs={24}>
            <FieldBlock 
              title={i18n.t('modals.modalEditContractOrder.fields.contractDate.title')} 
              name="contractDate" 
              getErrors={getFieldErrors}
            >
              <DatePicker
                style={{width: "100%"}}
                value={contractDate}
                format="DD.MM.YYYY"
                size="normal"
                name="contractDate"
                onChange={(date) => {
                  setContractDate(date);
                }}
              />
            </FieldBlock>
          </Col>
        </Row>

        {docsList.length > 0 && (
          <>
            <span className="divider-label">{i18n.t('modals.modalEditContractOrder.divider.docs')}</span>
            <DividerBlock style={dividerStyle}/>
            <Row gutter={16}>
              {renderDocsForm()}
            </Row>
          </>
        )}
      </Spin>
    </Modal>
  );
}